import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { Link, LinkProps } from 'react-router-dom';

type LinkButtonProps = ButtonProps & {
    to: LinkProps['to'];
    linkClassName?: string;
};

const LinkButton: React.FC<LinkButtonProps> = ({
    to,
    children,
    linkClassName = 'text-decoration-none',
    ...buttonProps
}) => {
    return (
        <Link to={to} className={linkClassName}>
            <Button {...buttonProps}>
                {children}
            </Button>
        </Link>
    );
};

export default LinkButton;